// Single source of truth for BIGA contact channels.
export const WHATSAPP_NUMBER = "919274793112";
export const PHONE_DISPLAY = "+91 92747 93112";
export const PHONE_TEL = "tel:+919274793112";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text || "")}`;
